import React, { useState, useEffect, useRef } from "react";
import Hamburger from "../header/hamburger";
import Menu from "../header/menu";
import SubpageHeader from "../header/subpageHeader";
import { useLocation } from "react-router-dom";
import SearchPanel from "../header/searchPanel";
import { useWindowSize } from "../../hooks";

const Layout = ({ children }) => {
  const [openBurger, setOpenBurger] = useState(false);
  const [openSearch, setOpenSearch] = useState(false);

  let { pathname } = useLocation();
  const size = useWindowSize();

  let subpage = pathname !== "/" ? true : false;





  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
    <div className="layout-container">
      {size.width > 428 ? (
        <Menu setOpenBurger={setOpenBurger} openBurger={openBurger} />
      ) : (
        <SearchPanel openSearch={openBurger} setOpenSearch={setOpenBurger} />
      )}
      <div>
        <SearchPanel openSearch={openSearch} setOpenSearch={setOpenSearch} />
      </div>

      <div className="main-header">
        {subpage && (
          <SubpageHeader
            setOpenSearch={setOpenSearch}
            openSearch={openSearch}
          />
        )}
        <div className="hamburger">
             <Hamburger setOpenBurger={setOpenBurger} openBurger={openBurger} />
        </div>
        {subpage && <div className={"header_border_bottom"} />}
      </div>
      <div className="main-content">{children}</div>
      <div className="main-footer" />
    </div>
    </>
  );
};

export default Layout;
